import styled from "styled-components";
export const ProfileContainer = styled.div`
  .letter {
    text-align: justify;
    margin-bottom: 24px;
    box-shadow: 0 0 10px 0 rgb(0 0 0 / 19%);
    font-size:80%;
    padding:16px;
    border-radius:10px;
    background:#f1f1f1;
  }
`;
